export default function getTextColor(intent, theme) {
  switch (intent) {
    case 'negative':
      return theme.palette.negative;

    case 'positive':
      return theme.palette.positive;

    case 'primary':
      return theme.palette.primary;

    case 'warning':
      return theme.palette.warning;

    case 'textSecondary':
      return theme.palette.text.secondary;

    case 'textTertiary':
      return theme.palette.text.tertiary;

    default:
      return theme.palette.text.primary;
  }
}